import { render } from "./SuspectOptions.vue?vue&type=template&id=66be4e1a"
import script from "./SuspectOptions.vue?vue&type=script&lang=js"
export * from "./SuspectOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__